<template>
  <div class="propertyBox">
    <money></money>
    <el-tabs v-model="activeName">
      <el-tab-pane label="账单明细" name="detailed"></el-tab-pane>
      <el-tab-pane label="提现记录" name="withdrawal" lazy></el-tab-pane>
    </el-tabs>
    <component :is="activeName"></component>
  </div>
</template>

<script>

import money from "./components/money"
import detailed from './components/detailed'
import withdrawal from './components/withdrawal'
export default {
  data () {
    return {
      activeName: 'detailed',
      detailed: detailed,
      withdrawal: withdrawal,
    }
  },
  components: {
    money, 
    detailed, 
    withdrawal
  },
}
</script>

<style lang="scss" scoped>
.routerBox {
  margin: 20px 0;
}
.routerItem {
  cursor: pointer;
  margin-right: 20px;
}
</style>
